// import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./i18n";
import * as serviceWorker from "./serviceWorker";

const container = document.getElementById("root");
const root = createRoot(container!);

// StrictMode is disabled because React 18 double rendering breaks MarkerClusterer (@react-google-maps/api)
// TODO: Re-enable when library supports StrictMode properly
root.render(
  // <StrictMode>
  <App />
  // </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
